import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import log_access from "@/api/log_access"

Vue.use(VueRouter)

const ifAdminAuthenticated = (to:any, from:any, next:any) => {
  if (localStorage.getItem('auth.user_id') && localStorage.getItem('auth.user_id') != ''
      && ['admin', 'webmaster', 'writer', 'manager'].includes(localStorage.getItem('auth.user_role') + '')) {
      next();
      return;
  }
  next('/admin');
}

const ifClientAuthenticated = (to:any, from:any, next:any) => {
  if (localStorage.getItem('auth.user_id') && localStorage.getItem('auth.user_id') != '' && localStorage.getItem('auth.user_role') == 'client') {
      next();
      return;
  }
  next('/client/login');
}

const ifAuthenticated = (to:any, from:any, next:any) => {
  if (localStorage.getItem('auth.user_id') && localStorage.getItem('auth.user_id') != '') {
      next();
      return;
  }
  next('/client/login');
}

function lazyLoad(view:string) {
  return () =>
      import (`@/views/${view}.vue`)
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: lazyLoad('client/LandingPage'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/recent-news',
    name: 'public.recent-news',
    component: lazyLoad('client/news/RecentNews'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/view-news',
    name: 'public.view-news',
    component: lazyLoad('client/news/ViewNews'),
    meta: { layout: 'client-layout' },
    props: true,
  },
  {
    path: '/news',
    name: 'public.news',
    component: lazyLoad('client/news/ViewNews'),
    meta: { layout: 'client-layout' },
    props: true,
  },
  {
    path: '/search-texts',
    name: 'public.search-texts',
    component: lazyLoad('client/texts/SearchTexts'),
    meta: { layout: 'client-layout' },
    props: true,
  },
  {
    path: '/magazine-editions',
    name: 'public.magazine-editions',
    component: lazyLoad('client/magazines/Editions'),
    meta: { layout: 'client-layout' },
    props: true,
  },
  {
    path: '/read-edition',
    name: 'public.read-edition',
    component: lazyLoad('client/magazines/ReadEdition'),
    meta: { layout: 'client-layout' },
    props: true,
  },
  {
    path: '/contact',
    name: 'public.contact',
    component: lazyLoad('client/Contact'),
    meta: { layout: 'client-layout' },
    props: true
  },
  {
    path: '/work',
    name: 'public.work_us',
    component: lazyLoad('client/WorkUs'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/products',
    name: 'public.products',
    component: lazyLoad('client/Products'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/legislations',
    name: 'public.legislations',
    component: lazyLoad('client/legislations/SearchLegislations'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/about',
    name: 'public.about',
    component: lazyLoad('client/About'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/collaborator',
    name: 'public.collaborator',
    component: lazyLoad('client/Collaborator'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/collaborators',
    name: 'public.collaborators',
    component: lazyLoad('client/Collaborators'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/promotional',
    name: 'public.promotional',
    component: lazyLoad('client/PromotionalClient'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/subscribe',
    name: 'public.subscribe',
    component: lazyLoad('client/Subscribe'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/certificates',
    name: 'public.certificates',
    component: lazyLoad('client/Certificates'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/summaries',
    name: 'public.summaries',
    component: lazyLoad('client/Summaries'),
    meta: { layout: 'client-layout' },
  },
  {
    path: '/magazine_edition_download',
    name: 'magazine_edition_download',
    component: lazyLoad('client/DownloadMagazineEdition'),
    beforeEnter: ifAuthenticated,
    meta: { layout: 'client-layout' },
  },
  {
    path: '/client',
    name: 'client',
    component: { render: h => h('router-view') },
    meta: { layout: 'client-layout' },
    children: [
      {
        path: 'login-icon',
        name: 'client.login-icon',
        component: lazyLoad('client/LoginIcon'),
        // meta: { layout: 'client-layout' },
      },
      {
        path: 'login',
        name: 'client.login',
        component: lazyLoad('client/LoginCliente'),
        meta: { layout: 'client-layout' },
      },
      {
        path: 'profile',
        name: 'client.profile',
        component: lazyLoad('client/Profile'),
        beforeEnter: ifClientAuthenticated,
        meta: { layout: 'client-layout' },
      },
      {
        path: 'history',
        name: 'client.history',
        component: lazyLoad('client/texts/History'),
        beforeEnter: ifClientAuthenticated,
        meta: { layout: 'client-layout' },
      },
      {
        path: 'dashboard',
        name: 'client.dashboard',
        component: lazyLoad('client/Dashboard'),
        beforeEnter: ifClientAuthenticated,
        meta: { layout: 'client-layout' },
      },
      {
        path: 'magazines',
        name: 'client.magazines',
        component: lazyLoad('client/Magazines'),
        beforeEnter: ifClientAuthenticated,
        meta: { layout: 'client-layout' },
      },
      {
        path: 'consultings',
        name: 'client.consultings',
        component: lazyLoad('client/consultings/ListConsultings'),
        meta: { layout: 'client-layout' },
        beforeEnter: ifClientAuthenticated,
      },
      
      {
        path: 'consulting',
        name: 'client.consulting',
        component: lazyLoad('client/consultings/Consulting'),
        meta: { layout: 'client-layout' },
        beforeEnter: ifClientAuthenticated,
        props: true,
      },
      {
        path: 'read-text',
        name: 'client.read-text',
        component: lazyLoad('client/texts/ReadText'),
        meta: { layout: 'client-layout' },
        beforeEnter: ifAuthenticated,
        props: true,
      },
      {
        path: 'legislation',
        name: 'client.legislation',
        component: lazyLoad('client/legislations/ReadLegislation'),
        meta: { layout: 'client-layout' },
        beforeEnter: ifClientAuthenticated,
        props: true,
      },
      {
        path: 'pdf-viewer',
        name: 'client.pdf-viewer',
        component: lazyLoad('client/PdfViewer'),
        meta: { layout: 'client-layout' },
        beforeEnter: ifClientAuthenticated,
        props: true,
      },
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: { render: h => h('router-view') },
    children: [
      {
        path:'',
        component: lazyLoad('admin/LoginAdmin'),
      },
      {
        path: 'login',
        name: 'admin.login',
        component: lazyLoad('admin/LoginAdmin'),
      },
      {
        path: 'dashboard',
        name: 'admin.dashboard',
        component: lazyLoad('admin/Dashboard'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'clients',
        name: 'admin.clients',
        component: lazyLoad('admin/clients/ListClients'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'client',
        name: 'admin.client',
        component: lazyLoad('admin/clients/Client'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'users',
        name: 'admin.users',
        component: lazyLoad('admin/users/ListUsers'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'user',
        name: 'admin.user',
        component: lazyLoad('admin/users/User'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'indices',
        name: 'admin.indices',
        component: lazyLoad('admin/indices/ListIndices'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'index',
        name: 'admin.index',
        component: lazyLoad('admin/indices/Index'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'texts',
        name: 'admin.texts',
        component: lazyLoad('admin/texts/ListTexts'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'text',
        name: 'admin.text',
        component: lazyLoad('admin/texts/Text'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'magazines',
        name: 'admin.magazines',
        component: lazyLoad('admin/magazines/ListMagazines'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'magazine',
        name: 'admin.magazine',
        component: lazyLoad('admin/magazines/Magazine'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'payment_methods',
        name: 'admin.payment_methods',
        component: lazyLoad('admin/payment_methods/ListPaymentMethods'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'payment_method',
        name: 'admin.payment_method',
        component: lazyLoad('admin/payment_methods/PaymentMethod'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'certificates',
        name: 'admin.certificates',
        component: lazyLoad('admin/certificates/ListCertificates'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'certificate',
        name: 'admin.certificate',
        component: lazyLoad('admin/certificates/Certificate'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'list-news',
        name: 'admin.list-news',
        component: lazyLoad('admin/news/ListNews'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'news',
        name: 'admin.news',
        component: lazyLoad('admin/news/News'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'products',
        name: 'admin.products',
        component: lazyLoad('admin/products/ListProducts'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'consultings',
        name: 'admin.consultings',
        component: lazyLoad('admin/consultings/ListConsultings'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'product',
        name: 'admin.product',
        component: lazyLoad('admin/products/Product'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'consulting',
        name: 'admin.consulting-answer',
        component: lazyLoad('admin/consultings/ConsultingAnswer'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'notifications',
        name: 'admin.notifications',
        component: lazyLoad('admin/notifications/ListNotifications'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'notification',
        name: 'admin.notification',
        component: lazyLoad('admin/notifications/Notification'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'newsletters',
        name: 'admin.newsletters',
        component: lazyLoad('admin/newsletters/ListNewsletters'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'newsletter',
        name: 'admin.newsletter',
        component: lazyLoad('admin/newsletters/Newsletter'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'legislation-categories',
        name: 'admin.legislation-categories',
        component: lazyLoad('admin/legislation_categories/ListLegislationCategories'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'legislation-category',
        name: 'admin.legislation-category',
        component: lazyLoad('admin/legislation_categories/LegislationCategory'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'legislations',
        name: 'admin.legislations',
        component: lazyLoad('admin/legislations/ListLegislations'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'legislation',
        name: 'admin.legislation',
        component: lazyLoad('admin/legislations/Legislation'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'authors',
        name: 'admin.authors',
        component: lazyLoad('admin/authors/ListAuthors'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'author',
        name: 'admin.author',
        component: lazyLoad('admin/authors/Author'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'errors',
        name: 'admin.errors',
        component: lazyLoad('admin/errors/ListErrors'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'error',
        name: 'admin.error',
        component: lazyLoad('admin/errors/Error'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'editions',
        name: 'admin.editions',
        component: lazyLoad('admin/magazine_editions/ListMagazineEditions'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'edition',
        name: 'admin.edition',
        component: lazyLoad('admin/magazine_editions/MagazineEdition'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'pages',
        name: 'admin.pages',
        component: lazyLoad('admin/content_pages/ListContentPages'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'page',
        name: 'admin.page',
        component: lazyLoad('admin/content_pages/ContentPage'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'system_parameters',
        name: 'admin.system_parameters',
        component: lazyLoad('admin/system_parameters/SystemParameters'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'report/text-access',
        name: 'admin.report-text-access',
        component: lazyLoad('admin/reports/TextAccess'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'report/daily-text-access',
        name: 'admin.report-daily-text-access',
        component: lazyLoad('admin/reports/DailyTextAccess'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'report/system-access',
        name: 'admin.report-system-access',
        component: lazyLoad('admin/reports/SystemAccess'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'magazine-sends',
        name: 'admin.magazines-sends',
        component: lazyLoad('admin/magazine_send/ListMagazineSends'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'magazine-send',
        name: 'admin.magazines-send',
        component: lazyLoad('admin/magazine_send/MagazineSend'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'summary',
        name: 'admin.summary',
        component: lazyLoad('admin/summaries/Summary'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'summaries',
        name: 'admin.summaries',
        component: lazyLoad('admin/summaries/ListSummaries'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'images',
        name: 'admin.images',
        component: lazyLoad('admin/image_archives/ListImageArchives'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'image',
        name: 'admin.image',
        component: lazyLoad('admin/image_archives/ImageArchive'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'courses',
        name: 'admin.courses',
        component: lazyLoad('admin/courses/ListCourses'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'course',
        name: 'admin.course',
        component: lazyLoad('admin/courses/Course'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'packages',
        name: 'admin.packages',
        component: lazyLoad('admin/packages/ListPackages'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'package',
        name: 'admin.package',
        component: lazyLoad('admin/packages/Package'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'video-lessons',
        name: 'admin.video-lessons',
        component: lazyLoad('admin/video_lessons/ListVideoLessons'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
      {
        path: 'video-lesson',
        name: 'admin.video-lesson',
        component: lazyLoad('admin/video_lessons/VideoLesson'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'banner',
        name: 'admin.banner',
        component: lazyLoad('admin/banners/Banner'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
        props: true,
      },
      {
        path: 'list-banners',
        name: 'admin.banners',
        component: lazyLoad('admin/banners/ListBanners'),
        meta: { layout: 'admin-layout' },
        beforeEnter: ifAdminAuthenticated,
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  log_access.accessControl();
  next();
})

export default router
